module.exports = __webpack_public_path__ + "img/myanmar.62780d15.svg";